import env from "../config/loadEnv";
require('../bootstrap');
const baseURL = env.baseURL;
const normalURL = env.normalURL;
const store = {
    state: {
        user: {
            id: 0,
            name: '',
            picture: '',
            job: '',
            email: '',
            role: ''
        },
        role: '',
        authenticated: false,
        token: '',
        api: baseURL,
        url: normalURL,
        //   logo: 'https://www.innovareti.com.br/img/logo.png'
    },
    getters: {
        token: state => {
            return state.token;
        },
        authenticated: state => {
            if (state.token == null || state.token == 'null') {
                return false;
            }
            return state.authenticated;
        },
        logo: state => {
            return state.logo;
        },
        user: state => {
            return state.user;
        },
        api: state => {
            return state.api;
        },
        role: state => {
            return state.role;
        }
    },
    mutations: {
        auth(state, token) {
            if (token) {
                state.authenticated = true;
                state.token = token;
                localStorage.clear();
                localStorage.setItem('token', token);
                axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('token');
                this.commit('profileUpdate');
            }
        },
        profileUpdate(state) {
            axios.post(state.api + 'me', {
                token: state.token
            })
                .then((response) => {
                    state.user.name = response.data.name;
                    state.user.email = response.data.email;
                    state.user.picture = response.data.photo;
                    state.user.role = response.data.role;
                    state.user.id = response.data.id;
                    localStorage.setItem('role', response.data.role);
                })
                .catch((error) => {
                    localStorage.clear();
                    this.$router.push('/login');
                });
        }
    },
    actions: {
        initialize(context) {
            const token = localStorage.getItem('token');
            context.commit('auth', token);
        }
    }
};
export default store;



// WEBPACK FOOTER //
// ./src/store/index.js